export default __webpack_public_path__ + "static/media/a6.b8ad0443.png";